var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Card",
    { attrs: { cardClass: " pb-0 customWidthTalent" } },
    [
      _c("div", { staticClass: "w-full p-4 pb-0" }, [
        _c("div", [
          _c("div", { staticClass: "flex flex-col" }, [
            _c(
              "div",
              {
                staticClass: "flex flex-row justify-between items-center mb-4",
              },
              [
                _c("Badge", {
                  staticClass: "inline mr-8",
                  attrs: {
                    value: _vm.status,
                    color: _vm.badgeColor,
                    styleClasses: "py-0.5 px-2",
                  },
                }),
                _c("CustomRequestActions", {
                  staticClass: "flex ml-auto",
                  attrs: {
                    requestId: this.request?.id,
                    currentStatus: this.request?.status,
                    isAdmin: _vm.isAdmin,
                    currentUserId: _vm.currentUserId,
                  },
                  on: { refetch: _vm.handleRefetch, message: _vm.message },
                  model: {
                    value: _vm.modalShown,
                    callback: function ($$v) {
                      _vm.modalShown = $$v
                    },
                    expression: "modalShown",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass:
                  "min-w-68 flex-grow xlLabelContainer order-2 md:order-1",
              },
              [
                _c("RouterLink", { attrs: { to: _vm.requestLink } }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "blueText truncate font-Outfit text-base font-bold mb-3",
                    },
                    [_vm._v(" " + _vm._s(_vm.requestJobTitle) + " ")]
                  ),
                ]),
                !_vm.createdByCurrentUser
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "flex justify-flex-start items-center text-storm-gray text-sm font-medium mb-2",
                      },
                      [
                        _c("UserIcon", { staticClass: "pr-2 w-auto h-auto" }),
                        _c(
                          "span",
                          {
                            staticClass:
                              "text-primary-black font-400 text-sm pr-2",
                          },
                          [_vm._v("Requested by")]
                        ),
                        _vm.requestCreatorLink
                          ? _c(
                              "RouterLink",
                              { attrs: { to: _vm.requestCreatorLink } },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "text-storm-gray text-sm font-medium rounded-full border border-gray-300 px-1 py-1.5 bg-white hover:text-primary-500 hover:border-primary-500",
                                  },
                                  [
                                    _vm.request?.created_by.avatar
                                      ? _vm._t(
                                          "image flex-shrink-0 span-fix mt-2.5",
                                          function () {
                                            return [
                                              _c("S3Image", {
                                                class: [
                                                  _vm.defaultImageClasses,
                                                  _vm.avatarStyleClasses,
                                                ],
                                                attrs: {
                                                  s3FileKey:
                                                    _vm.request?.created_by
                                                      .avatar,
                                                },
                                              }),
                                            ]
                                          },
                                          {
                                            defaultClasses: [
                                              _vm.defaultImageClasses,
                                              _vm.avatarStyleClasses,
                                            ],
                                            image:
                                              _vm.request?.created_by.avatar,
                                          }
                                        )
                                      : _vm._e(),
                                    !_vm.request?.created_by.avatar
                                      ? _c(
                                          "span",
                                          {
                                            class: [
                                              _vm.defaultInitialsClasses,
                                              _vm.avatarStyleClasses,
                                            ],
                                            style: _vm.bgStyle,
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-xs leading-none font-semibold text-white",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(_vm.initial) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.request?.created_by.given_name
                                        ) +
                                        " " +
                                        _vm._s(
                                          _vm.request?.created_by.family_name
                                        ) +
                                        " "
                                    ),
                                  ],
                                  2
                                ),
                              ]
                            )
                          : _c(
                              "span",
                              {
                                staticClass:
                                  "text-storm-gray text-sm font-medium",
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.requestCreatorName) + " "
                                ),
                              ]
                            ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass:
                      "flex justify-flex-start items-center text-storm-gray text-sm font-medium mb-2",
                  },
                  [
                    _c("DollarIcon", { staticClass: "pr-2 w-auto h-auto" }),
                    _c(
                      "span",
                      {
                        staticClass:
                          "text-primary-black font-400 text-sm pr-2 titleText",
                      },
                      [_vm._v("Budget/Rate")]
                    ),
                    _vm._v(_vm._s(_vm.Rate) + " "),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "flex justify-flex-start items-center text-storm-gray text-sm font-medium mb-2",
                  },
                  [
                    _c("ProfileIcon", { staticClass: "pr-2 w-auto h-auto" }),
                    _c(
                      "span",
                      {
                        staticClass:
                          "text-primary-black font-400 text-sm pr-2 titleText",
                      },
                      [_vm._v("Type ")]
                    ),
                    _vm.request?.tag !== null
                      ? _c("p", [_vm._v(_vm._s(_vm.request?.tag.name))])
                      : _c("p", [_vm._v("n/a")]),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "flex justify-flex-start items-center text-storm-gray text-sm font-medium mb-2",
                  },
                  [
                    _c("CalendarIcon", { staticClass: "pr-2 w-auto h-auto" }),
                    _c(
                      "span",
                      {
                        staticClass:
                          "text-primary-black font-400 text-sm pr-2 titleText",
                      },
                      [_vm._v("Duration")]
                    ),
                    _vm._v(
                      _vm._s(_vm.startDate(_vm.request?.from_date)) +
                        " - " +
                        _vm._s(_vm.endDate(_vm.request?.to_date)) +
                        " "
                    ),
                  ],
                  1
                ),
                _c("SuitableResources", {
                  attrs: {
                    skillIds: _vm.skillIds,
                    name: _vm.requestJobTitle,
                    excludeResourceUserId: _vm.excludeResourceUserId,
                    companyId: _vm.companyId,
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "w-full" }, [
        _c(
          "div",
          {
            staticClass:
              "flex gap-1 w-full skills-footer items-center pt-4 border-t px-4 border-opacity-5",
          },
          [
            _vm._v(" Skills: "),
            _vm.requestSkillsTalent.length > 0
              ? _c(
                  "div",
                  { staticClass: "flex flex-row gap-1 items-center" },
                  [
                    _vm._l(
                      _vm.requestSkillsTalent.slice(0, 3),
                      function (skill) {
                        return _c(
                          "div",
                          { key: skill.id, staticClass: "skills-chip" },
                          [_vm._v(" " + _vm._s(skill.name) + " ")]
                        )
                      }
                    ),
                    _vm.requestSkillsTalent.length > 3
                      ? _c("div", [
                          _c("div", { staticClass: "skills-chip-plus" }, [
                            _vm._v(
                              " +" +
                                _vm._s(_vm.requestSkillsTalent.length - 3) +
                                " "
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ],
                  2
                )
              : _c("div", [_vm._v("n/a")]),
          ]
        ),
      ]),
      _vm.modalShown
        ? _c("CustomRequestModal", {
            attrs: {
              currentUserId: _vm.currentUserId,
              companyId: _vm.companyId,
              customRequest: _vm.request,
              skills: _vm.skillIds,
              isAdmin: _vm.isAdmin,
            },
            on: { close: _vm.toggleRequestModal, refetch: _vm.handleRefetch },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }